import { createContext } from "react";
const ApiKeyContext = createContext({
	'api-key': null,
});
export default ApiKeyContext;
